import React from "react";
import { Col, Row, Button, Input, UncontrolledTooltip } from "reactstrap";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { DEMO_FEATURE_UNAVAILABLE, isDemoLocked } from "../utils/demoConfig";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const demoLockedControl = (tooltipId, control) => (
  <>
    <span id={tooltipId}>{control}</span>
    <UncontrolledTooltip placement="top" trigger="hover" target={tooltipId}>
      {DEMO_FEATURE_UNAVAILABLE}
    </UncontrolledTooltip>
  </>
);

const SubuserInvoiceUserViewTable = ({ tableData, searchQuery, defaultSorted }) => {
  const { ExportCSVButton } = CSVExport;

  const currencies = ["€", "$", "£"];

  const amountFormatter = (cell, row) => `${cell}${currencies[row.currency]}`;

  const downloadFormatter = (cell, row) => {
    const tooltipId = `subuser-invoice-pdf-user-${row.id}`;
    const button = (
      <Button
        className="btn-status"
        color="primary"
        disabled
        style={{ pointerEvents: "none" }}
      >
        <b>Download</b>
      </Button>
    );

    if (isDemoLocked()) {
      return demoLockedControl(tooltipId, button);
    }

    return cell ? (
      <a href={cell} target="blank" rel="noreferrer">
        <Button className="btn-status" color="primary">
          <b>Download</b>
        </Button>
      </a>
    ) : null;
  };

  const statusFormatter = cell => {
      //  0 => Pending
      //  1 => Accepted
      //  2 => Rejected
      //  3 => Paid
      //  4 => Generating
      return (
        <>
          {cell === 0 ? (
            <Button className="btn-status" disabled color="warning">
              Pending
            </Button>
          ) : cell === 1 ? (
            <Button className="btn-status" disabled color="success">
              Accepted
            </Button>
          ) : cell === 2 ? (
            <Button className="btn-status" disabled color="danger">
              Rejected
            </Button>
          ) : cell === 3 ? (
            <Button className="btn-status" disabled color="success">
              Paid
            </Button>
          ) : cell === 4 ? (
            <Button className="btn-status" disabled color="warning">
              Generating
            </Button>
          ) : null}
        </>
      );
    };

  const statusCsvFormatter = (cell) => {
    if (cell === 0) return "Pending";
    if (cell === 1) return "Accepted";
    if (cell === 2) return "Rejected";
    if (cell === 3) return "Paid";
    if (cell === 4) return "Generating";
    return "";
  };

  const columns = [
    {
      dataField: "issue_date",
      text: "Issue Date",
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "invoice_number",
      text: "Invoice Number",
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "gross_amount",
      text: "Gross Amount",
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "tax_amount",
      text: "Tax Amount",
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "net_amount",
      text: "Net Amount",
      sort: true,
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "status",
      text: "Status",
      formatter: statusFormatter,
      csvFormatter: statusCsvFormatter,
      sort: true,
      headerStyle: () => ({ width: "120px" })
    },
    {
      dataField: "invoice_pdf",
      text: "Download PDF",
      formatter: (cell, row) => downloadFormatter(cell, row),
      headerStyle: () => ({ width: "100px" })
    },
    {
      dataField: "name",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "issue_date" || sortField === "invoice_number" || sortField === "status" || sortField === "net_amount") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="id"
      data={Array.isArray(tableData) ? tableData : []}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "invoices.csv" }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder="Search..."
                  value={searchQuery.query}
                  style={{ marginBottom: 10 }}
                  onChange={e => searchQuery.setQuery(e.target.value)}
                />
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  Export CSV
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default SubuserInvoiceUserViewTable;